// // helpers/UserDetails.js
// const KEY = 'userDetails'; // Change to match what AuthStatus expects

// export function saveUserDetailsInLocalStorage(user) {
//     try {
//         if (!user) {
//             console.warn("Attempted to save null user to localStorage");
//             return;
//         }
//         localStorage.setItem(KEY, JSON.stringify(user));
//         console.log('💾 Saved user to localStorage with key:', KEY, user);
//     } catch (error) {
//         console.error("Error saving user details to localStorage:", error);
//     }
// }

// export function getUserDetailsInLocalStorage() {
//     try {
//         const userStr = localStorage.getItem(KEY);
//         if (!userStr) {
//             console.log('🔍 No user found for key:', KEY);
//             // Return a safe default object instead of null
//             return {
//                 role: null,
//                 scope: "",
//                 name: null,
//                 email: null,
//                 designation: null,
//                 photo: null
//             };
//         }
//         const user = JSON.parse(userStr);
//         console.log('🔍 Retrieved user for key:', KEY, user);
        
//         // Ensure the object has expected properties with safe defaults
//         return {
//             role: user?.role || null,
//             scope: user?.scope || "",
//             name: user?.name || null,
//             email: user?.email || null,
//             designation: user?.designation || null,
//             photo: user?.photo || null,
//             ...user // spread any additional properties
//         };
//     } catch (error) {
//         console.error("Error parsing user details from localStorage:", error);
//         // Return safe default instead of null
//         return {
//             role: null,
//             scope: "",
//             name: null,
//             email: null,
//             designation: null,
//             photo: null
//         };
//     }
// }

// export function clearUserDetailsInLocalStorage() {
//     try {
//         localStorage.removeItem(KEY);
//         console.log('🗑️ Cleared user from localStorage for key:', KEY);
//     } catch (error) {
//         console.error("Error clearing user details from localStorage:", error);
//     }
// }

// helpers/UserDetails.js
const KEY = 'userDetails';

export function saveUserDetailsInLocalStorage(user) {
    try {
        if (!user) {
            console.warn("❌ Attempted to save null user to localStorage");
            return;
        }
        
        // Add timestamp for token expiration tracking
        const userWithTimestamp = {
            ...user,
            _savedAt: Date.now()
        };
        
        localStorage.setItem(KEY, JSON.stringify(userWithTimestamp));
        console.log('💾 Saved user to localStorage:', { 
            key: KEY, 
            hasToken: !!user.token,
            role: user.role 
        });
    } catch (error) {
        console.error("❌ Error saving user details to localStorage:", error);
    }
}

export function getUserDetailsInLocalStorage() {
    try {
        const userStr = localStorage.getItem(KEY);
        if (!userStr) {
            console.log('🔍 No user found in localStorage');
            return null; // Return null to clearly indicate no user
        }
        
        const user = JSON.parse(userStr);
        
        // Check if token exists (critical for auth)
        if (!user?.token) {
            console.warn('⚠️ User found but no token - clearing invalid data');
            clearUserDetailsInLocalStorage();
            return null;
        }
        
        console.log('🔍 Retrieved user:', { 
            hasToken: !!user.token,
            role: user.role 
        });
        
        return user;
        
    } catch (error) {
        console.error("❌ Error parsing user details:", error);
        clearUserDetailsInLocalStorage(); // Auto-clean corrupted data
        return null;
    }
}

export function clearUserDetailsInLocalStorage() {
    try {
        // Clear all related auth keys to ensure complete cleanup
        const authKeys = [
            KEY, 
            'userDetails', 
            'token', 
            'refreshToken',
            'authToken'
        ];
        
        authKeys.forEach(key => {
            localStorage.removeItem(key);
            console.log(`🗑️ Cleared: ${key}`);
        });
        
        console.log('✅ All authentication data cleared from localStorage');
        
    } catch (error) {
        console.error("❌ Error clearing user details:", error);
    }
}

// NEW: Helper to check if token might be expired
export function isTokenLikelyExpired() {
    const user = getUserDetailsInLocalStorage();
    if (!user || !user.token) return true;
    
    try {
        // Decode JWT payload
        const parts = user.token.split('.');
        if (parts.length === 3) {
            const base64Url = parts[1];
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            const jsonPayload = decodeURIComponent(
                atob(base64)
                    .split('')
                    .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                    .join('')
            );
            const payload = JSON.parse(jsonPayload);
            if (payload && payload.exp) {
                // Return true if expired (with 10-second buffer)
                return Date.now() >= (payload.exp * 1000 - 10000);
            }
        }
    } catch (e) {
        console.error("Error decoding token for expiry check:", e);
    }

    if (!user._savedAt) return true;
    const TWENTY_THREE_HOURS = 23 * 60 * 60 * 1000;
    const timeSinceSave = Date.now() - user._savedAt;
    return timeSinceSave > TWENTY_THREE_HOURS;
}

// NEW: Helper to get just the token safely
export function getAuthToken() {
    const user = getUserDetailsInLocalStorage();
    return user?.token || null;
}